import { lazy } from "react";

// Audit Rules — administración del catálogo de reglas del auditor de notas
// clínicas (crear / editar / aprobar / deshabilitar sin tocar código).
// Guía: docs/modulos/AuditorRules/MODULO-REGLAS-AUDITORIA.md
// El GET del catálogo es real (§1); las escrituras son preview local hasta el
// backend de §4 (2026-10-18/19).
//
// ACCESO (desde 2026-10-20): lo decide ROUTE_ALLOWED_EMPLOYEE_IDS en
// roleRoutePermissions.js — admin/CEO (adminBypass) + employee 80. La key
// pendiente `audit_rules` queda de respaldo hasta que backend cree el módulo en
// TAB_MODULES y la matriz RBAC decida el resto de roles (§4.4 separa ver/usar
// el auditor de administrar reglas).
const AuditRulesPage = lazy(() => import("./pages/AuditRulesPage"));

export const auditRulesRoutes = [{ path: "/audit-rules", element: <AuditRulesPage /> }];
